<template>
    <div class="dashboard-info-page">

        <section class="welcome-card">
            <div>
                <span class="badge">Portal do Estabelecimento</span>

                <h1>Bem-vindo ao SGSIM</h1>

                <h4>
                    Utilize este ambiente para acompanhar informações do estabelecimento,
                    consultar documentos, verificar registros e manter os dados sempre atualizados.
                </h4>
            </div>
        </section>

        <section class="info-grid">

            <div class="info-card">
                <div class="icon">📄</div>
                <h3>Documentos e anexos</h3>
                <p>
                    Consulte os documentos vinculados ao estabelecimento, acompanhe
                    vencimentos e mantenha os anexos sempre atualizados.
                </p>
            </div>

            <div class="info-card">
                <div class="icon">📝</div>
                <h3>Registros e informações</h3>
                <p>
                    Mantenha os dados cadastrais corretos e acompanhe as informações
                    relacionadas às atividades do estabelecimento.
                </p>
            </div>

            <div class="info-card">
                <div class="icon">🔍</div>
                <h3>Consultas</h3>
                <p>
                    Utilize as ferramentas de consulta para localizar documentos,
                    registros e informações do processo de inspeção.
                </p>
            </div>

            <div class="info-card">
                <div class="icon">📌</div>
                <h3>Acompanhamento</h3>
                <p>
                    Verifique regularmente as informações disponíveis no sistema
                    para manter o acompanhamento das atividades e procedimentos.
                </p>
            </div>

        </section>

    </div>
</template>

<script>
export default {
    name: 'EstabelecimentoInfoPage',
};
</script>

<style scoped>
.dashboard-info-page {
    padding: 20px;
}

.welcome-card {
    background: linear-gradient(135deg,#f8fafc,#eef2ff);
    border: 1px solid #dbe3f0;
    border-radius: 14px;
    padding: 24px;
    margin-bottom: 20px;
    box-shadow: 0 4px 12px rgba(15,23,42,.06);
}

.badge{
    display:inline-block;
    background:#e0e7ff;
    color:#3730a3;
    font-size:12px;
    font-weight:700;
    padding:5px 10px;
    border-radius:999px;
    margin-bottom:10px;
}

.welcome-card h1{
    margin:0 0 8px;
    color:#1f2937;
    font-size:26px;
}

.welcome-card p{
    margin:0;
    color:#4b5563;
    line-height:1.5;
    max-width:850px;
}

.info-grid{
    display:grid;
    grid-template-columns:repeat(auto-fit,minmax(240px,1fr));
    gap:16px;
}

.info-card{
    background:#fff;
    border:1px solid #e5e7eb;
    border-radius:12px;
    padding:18px;
    box-shadow:0 2px 8px rgba(15,23,42,.04);
    transition:.2s;
}

.info-card:hover{
    transform:translateY(-3px);
}

.icon{
    font-size:28px;
    margin-bottom:8px;
}

.info-card h3{
    margin:0 0 8px;
    color:#1f2937;
    font-size:17px;
}

.info-card p{
    margin:0;
    color:#6b7280;
    line-height:1.5;
    font-size:14px;
}
</style>